webpackJsonp([19505292334457],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 33.3%;\n  padding: 1%;\n'], ['\n  width: 33.3%;\n  padding: 1%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(17);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardWrapper = _styledComponents2.default.div(_templateObject);
	
	var EpisodeCard = function EpisodeCard(_ref) {
	  var episode = _ref.episode;
	
	  if (episode) {
	    return _react2.default.createElement(
	      CardWrapper,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/episode/' + episode.episodeId },
	        _react2.default.createElement(
	          _theme.Card,
	          null,
	          _react2.default.createElement(_theme.CardImage, { src: [episode.posterUrl, "/img/episode_no_image.png"], alt: episode.title })
	        )
	      )
	    );
	  } else {
	    return _react2.default.createElement('div', null);
	  }
	};
	
	exports.default = EpisodeCard;
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgramContainer = function ProgramContainer(props) {};
	
	exports.default = ProgramContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProgramContainer = __webpack_require__(397);
	
	var _ProgramContainer2 = _interopRequireDefault(_ProgramContainer);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _layout = __webpack_require__(16);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(17);
	
	var _EpisodeCard = __webpack_require__(190);
	
	var _EpisodeCard2 = _interopRequireDefault(_EpisodeCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProgramWrapper = _styledComponents2.default.div(_templateObject);
	
	var ProgramPage = function ProgramPage(props) {
	  var program = props.pathContext.data;
	  var episodes = props.episodes;
	
	  program.episodes = episodes.filter(function (obj) {
	    return obj.programId === program.programId;
	  });
	  return _react2.default.createElement(
	    _layout.FrameContainer,
	    null,
	    _react2.default.createElement(_reactHelmet.Helmet, {
	      title: program.title,
	      meta: [{ name: 'description', content: program.title + ':' + program.summary + ':' + props.meta.description }]
	    }),
	    _react2.default.createElement(
	      ProgramWrapper,
	      null,
	      _react2.default.createElement('img', { src: program.thumbnailUrl, alt: program.title }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        program.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        program.summary
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u30A8\u30D4\u30BD\u30FC\u30C9\u4E00\u89A7'
	    ),
	    _react2.default.createElement(
	      _theme.EpisodeCardWrapper,
	      null,
	      program.episodes.map(function (episode) {
	        return _react2.default.createElement(_EpisodeCard2.default, { episode: episode, key: episode.episodeId });
	      })
	    )
	  );
	};
	
	exports.default = ProgramPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-program-js-533b82900ebac5c1f8a6.js